import type {
  GetStartedSettingsContribution,
  GetStartedSettingsRegistrar,
} from '../models/getStarted.types'

let contribution: GetStartedSettingsContribution | null = null
let sealed = false

/**
 * Install the one workspace-settings surface contributed to Get Started. Re-installing the exact
 * same descriptor is a no-op so a repeated app bootstrap is safe; a second owner is a wiring bug.
 */
export const registerGetStartedSettingsSurface: GetStartedSettingsRegistrar = (next) => {
  if (contribution?.key === next.key && contribution.component === next.component) return
  if (sealed) {
    throw new Error('[global-surface] Get Started settings registration ran after router creation')
  }
  if (contribution) {
    throw new Error(
      `[global-surface] duplicate Get Started settings contribution "${next.key}"; ` +
        `"${contribution.key}" already owns the slot`,
    )
  }
  contribution = next
}

export function getStartedSettingsSurface(): GetStartedSettingsContribution | null {
  return contribution
}

/** Router creation closes composition; an unregistered surface remains a valid pre-cutover state. */
export function sealGetStartedSettingsSurface(): void {
  sealed = true
}

/** Test isolation only. Product code registrations are static for the app lifetime. */
export function resetGetStartedSettingsSurface(): void {
  contribution = null
  sealed = false
}
